document.addEventListener('DOMContentLoaded', function() {


    var productId = ShopifyAnalytics.meta.product.id; // Get the current product ID
    var productVendor = ShopifyAnalytics.meta.product.vendor; // Get the product vendor
    var productVariants = window.productVariants || []; // Default to an empty array if no variants are available
    const variantSelectElements = document.querySelectorAll('variant-selects, variant-radios');

    // The exact Shopify location name for the European warehouse.
    // Must match Settings > Locations in Shopify Admin exactly.
    var EU_WAREHOUSE_LOCATION_NAME = 'European Warehouse (Dispatch 5-10 Working Days)';

    // Function to get delivery days based on the vendor and warehouse region ('UK' or 'EU')
    function getDeliveryDays(vendor, region) {
        var delaysMap = region === 'EU' ? window.vendorDelaysEU : window.vendorDelays;

        // If the vendor exists in the region's list, return the respective delivery time
        if (delaysMap && delaysMap.hasOwnProperty(vendor)) {
            return delaysMap[vendor];
        }

        // Fall back to the region's default lead time, if one is set (EU only)
        if (region === 'EU' && window.defaultEUDeliveryDays) {
            return window.defaultEUDeliveryDays;
        }

        // If vendor is not in the list, return default "2-3 working days"
        return null;
    }

    function findVariant(selectedOptions) {
        return productVariants.find(variant => {
            return variant.options.every((option, index) => option === selectedOptions[index]);
        });
    }

    function handleVariantChange(variantSelect) {
        // Clear previous inventory information
        const inventoryInfoContainer = document.querySelector('#inventory-info');
        if (inventoryInfoContainer) {
            inventoryInfoContainer.innerHTML = ''; // Clear the previous variant's inventory info
        }

        // Get delivery days for the current product vendor (UK warehouse)
        const deliveryDays = getDeliveryDays(productVendor, 'UK');

        // Find the appropriate DOM element and update it with the delivery days
        const deliveryInfoElement = document.querySelector('#delivery-info'); // Adjust the selector as per your HTML
        if (deliveryInfoElement) {
            if (deliveryDays) {
                // Only display the message if deliveryDays is not null
                deliveryInfoElement.textContent = `Dispatched within ${deliveryDays}`;
                deliveryInfoElement.style.display = 'block'; // Ensure it's visible
            } else {
                // Hide the element if the vendor is not in the list
                deliveryInfoElement.style.display = 'none';
            }
        }

        // Get the selected options
        const selectedOptions = Array.from(variantSelect.querySelectorAll('input[type="radio"]:checked'))
            .map(option => option.value);

        console.log(selectedOptions);

        if (selectedOptions.length > 0) {
            const selectedVariant = findVariant(selectedOptions);

            if (selectedVariant) {
                fetchInventoryDetails(productId, selectedVariant.id);
            } else {
                console.error('No variant found for the selected options.');
            }
        } else {
            console.error('No variant options selected.');
        }
    }

    async function fetchInventoryDetails(productId, variantId = null) {
        try {
            // Fetch product data
            const productResponse = await fetch(`https://europe-west2-winter-cocoa-423316-v0.cloudfunctions.net/inventoryProxy?endpoint=products/${productId}.json`, {
                method: 'GET'
            });
            const productData = await productResponse.json();
            console.log('Product Data:', productData);

            let variant;

            // If a variant ID is provided, find the variant
            if (variantId) {
                variant = productData.product.variants.find(v => v.id === variantId);
                if (!variant) {
                    throw new Error('Variant ID not found in the product data.');
                }
            } else if (productData.product.variants.length > 0) {
                // If no variant ID, use the first available variant
                variant = productData.product.variants[0];
            }

            const inventoryItemId = variant ? variant.inventory_item_id : productData.product.id;
            console.log('Inventory Item ID:', inventoryItemId);

            // Fetch locations data
            const locationsResponse = await fetch(`https://europe-west2-winter-cocoa-423316-v0.cloudfunctions.net/inventoryProxy?endpoint=locations.json`, {
                method: 'GET'
            });
            const locationsData = await locationsResponse.json();
            console.log('Locations Data:', locationsData);

            const locations = locationsData.locations;

            document.querySelector('.product-form #inventory-info').innerHTML = '';

            // Fetch inventory levels for all locations at once
            const inventoryResponse = await fetch(`https://europe-west2-winter-cocoa-423316-v0.cloudfunctions.net/inventoryProxy?endpoint=inventory_levels.json&params=inventory_item_ids=${inventoryItemId}`, {
                method: 'GET'
            });
            const inventoryData = await inventoryResponse.json();
            console.log('Inventory Levels:', inventoryData);

            const inventoryLevels = inventoryData.inventory_levels;


            // Drive the same-day dispatch countdown block with real,
// per-location stock (not just Shopify's "available" flag,
// which can stay true at zero stock for backorder/continue-
// selling or in-transfer items).
const dispatchCountdownEl = document.querySelector('dispatch-countdown');
if (dispatchCountdownEl && typeof dispatchCountdownEl.setStockState === 'function') {
    let alansBmxQty = 0;
    let otherLocationsQty = 0;

    for (const location of locations) {
        const levelEntry = inventoryLevels.find(level => level.location_id === location.id);
        const qty = levelEntry ? levelEntry.available : 0;

        if (location.name === 'AlansBMX') {
            alansBmxQty += qty;
        } else {
            otherLocationsQty += Math.max(qty, 0);
        }
    }

    if (alansBmxQty > 0) {
        dispatchCountdownEl.setStockState('same_day');
    } else if (otherLocationsQty > 0) {
        dispatchCountdownEl.setStockState('special_order');
    } else {
        dispatchCountdownEl.setStockState('hidden');
    }
}

            let inventoryFound = false;
            const deliveryDays = getDeliveryDays(productVendor, 'UK') || "2-3 days";

            // Build each location's markup first, then append them in a fixed
            // display order (AlansBMX, then UK Warehouse, then European
            // Warehouse) regardless of the order the API returns locations in.
            let alansInfoHtml = null;
            let ukInfoHtml = null;
            let euInfoHtml = null;

            // Iterate through each location
            for (const location of locations) {
                const inventoryLevelEntry = inventoryLevels.find(level => level.location_id === location.id);
                if (inventoryLevelEntry && inventoryLevelEntry.available > 0) {
                    inventoryFound = true;
                    const inventoryLevel = inventoryLevelEntry.available;
                    const locationName = location.name;

                    if (locationName == 'AlansBMX') {
                        alansInfoHtml = `<span><svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18">
        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#45967e"></path>
        <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
      </svg> Stock at AlansBMX Store: ${inventoryLevel}</span>`;
                    } else if (locationName === EU_WAREHOUSE_LOCATION_NAME) {
                        const euDeliveryDays = getDeliveryDays(productVendor, 'EU');
                        euInfoHtml = `<span class="warehouse-eu"><svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18">
        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#45967e"></path>
        <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
  </svg> Stock at European Warehouse: ${inventoryLevel}` + (euDeliveryDays ? ` <small>(Dispatch ${euDeliveryDays})</small>` : '') + `</span>`;
                    } else {
                        ukInfoHtml = `<span class="warehouse"><svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18">
        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#45967e"></path>
        <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
  </svg> Stock at Supplier Warehouse: ${inventoryLevel}` + (deliveryDays ? ` <small>(Dispatch ${deliveryDays})</small>` : '') + `</span>`;
                    }
                }
            }

            // Append in the desired order: AlansBMX, UK Warehouse, European Warehouse
            const inventoryInfoContainerEl = document.querySelector('#inventory-info');
            [alansInfoHtml, ukInfoHtml, euInfoHtml].forEach((html) => {
                if (html) {
                    const inventoryInfo = document.createElement('div');
                    inventoryInfo.innerHTML = html;
                    inventoryInfoContainerEl.appendChild(inventoryInfo);
                }
            });

            // If no specific inventory is found, display the "Available" number from the product
            if (!inventoryFound) {
                    if(variant.inventory_policy == 'continue'){
                   let preOrderMessage =  document.querySelector('#pre-order-message');
                   if(preOrderMessage){
                       preOrderMessage.style.display = "block";
                   }else{
                       const preOrderMessageDiv = document.createElement('div');
                       preOrderMessageDiv.innerHTML = `<span style="text-align: center" class="preorder-date" id="pre-order-message">Special Order from the Suppliers: Usually available ${deliveryDays}! Call us to check availability</span>`;
                       // Find the target element before which you want to insert the new div
                       const targetElement = document.querySelector('.product-form__buttons .button--primary');

                       if (targetElement && targetElement.parentNode) {
                           targetElement.parentNode.insertBefore(preOrderMessageDiv, targetElement);
                       }
                   }
                    // document.querySelector('.product-form__buttons .button--primary').innerHTML = "<span>Add Pre Order Item to Cart</span>";
                }
                const availableQuantity = variant ? variant.inventory_quantity : productData.product.inventory_quantity;

                if (availableQuantity > 0) {
                    const inStoreInfo = document.createElement('div');
                    inStoreInfo.innerHTML = `<span><svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18">
        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#45967e"></path>
        <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
      </svg> ${availableQuantity} in stock <small>available in store</small></span>`;
                    document.querySelector('#inventory-info').appendChild(inStoreInfo);
                } else {
                    console.error('No available quantity found for the product.');
                }
            }else{
                document.querySelector('#pre-order-message').style.display = "none";

            }

        } catch (error) {
            console.error('Error fetching inventory details:', error);
        }
    }

    // If there are no variant select elements but there are variants, default to the first variant
    if (variantSelectElements.length === 0 && productVariants.length > 0) {
        console.log('No variant selection elements, defaulting to first variant');
        const firstVariant = productVariants[0];
        fetchInventoryDetails(productId, firstVariant.id);
    } else {
        // Add event listener to each variant select element
        variantSelectElements.forEach(variantSelect => {
            variantSelect.addEventListener('change', function(event) {
                handleVariantChange(variantSelect);
            });

            // Handle initial load
            handleVariantChange(variantSelect);
        });
    }

    // Call the handleVariantChange on page load to set the delivery time initially


});